import type { FC, ReactNode } from 'react';

import { IcoMoonIcon } from '@wwe-portal/ui/components/icons/icomoon';
import { Skeleton, TextSkeleton } from '@wwe-portal/ui/components/skeleton';
import { tryFormatThousands } from '@wwe-portal/utils/format';

export interface UserBadgesProps {
  rosterPower: number;
  rosterPowerLabel: string;
  league: number;
  leagueLabel: string;
}
const Badge: FC<{ amount: ReactNode; name: ReactNode; icon: ReactNode }> = ({
  amount,
  name,
  icon,
}) => {
  return (
    <div className="flex items-start gap-1">
      {icon}
      <div className="flex flex-col">
        <div className="text-text300 text-sm font-medium">{amount}</div>
        <div className="text-text700 text-2xs">{name}</div>
      </div>
    </div>
  );
};

export const UserBadges: FC<UserBadgesProps> = ({
  leagueLabel,
  league,
  rosterPowerLabel,
  rosterPower,
}) => {
  return (
    <div className="bg-back300 flex justify-between rounded-lg p-4">
      <Badge
        amount={tryFormatThousands(rosterPower)}
        icon={
          <IcoMoonIcon className="text-green700 size-[18px]" iconName="flash" />
        }
        name={rosterPowerLabel}
      />
      <Badge
        amount={league}
        icon={
          <IcoMoonIcon
            className="text-purple800 size-[18px]"
            iconName="rewards-cup"
          />
        }
        name={leagueLabel}
      />
    </div>
  );
};

const SkeletonBadge = () => (
  <Badge
    amount={<TextSkeleton className="w-10" fontSize={14} lineHeight={20} />}
    icon={<Skeleton className="size-[18px]" />}
    name={<TextSkeleton className="w-20" fontSize={10} lineHeight={15} />}
  />
);

export const UserBadgesSkeleton = () => {
  return (
    <div className="flex justify-between rounded-lg p-4">
      <SkeletonBadge />
      <SkeletonBadge />
    </div>
  );
};
